import { Response } from '@marketplace-web/core-api/api-client-util'
import { transformPaginationDto } from '@marketplace-web/shared/pagination-data'
import {
  ProductItemModel,
  transformItemBoxDto,
  transformPartialUserDtoToProductItemUser,
} from '@marketplace-web/item-box/product-item-data'

import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'
import { findThumbnail } from '@marketplace-web/shared/utils'

import { BundleItemDto, UserBundleItemsModel, UserBundleItemsResp } from '../types/bundle-items'

enum ItemThumbnailSize {
  Medium = 'thumb150x210',
  Large = 'thumb310x430',
}

const getItemThumbnail = (
  photos: Array<{
    is_main: boolean
    thumbnails: Array<{ type: ItemThumbnailSize | string; url: string }>
  }>,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ is_main }) => is_main)

  return findThumbnail(photo, size)
}

const getDominantColor = (photos: Array<{ is_main: boolean; dominant_color_opaque: string }>) => {
  if (!photos.length) return null

  const photo = photos.find(({ is_main }) => is_main === true)

  if (!photo) return null

  return photo.dominant_color_opaque
}

export const transformBundleItemDtoToProductItem = (item: BundleItemDto): ProductItemModel => ({
  id: item.id,
  title: item.title,
  url: '',
  photos: item.photos.map(photo => ({
    url: photo.url,
    thumbnails: photo.thumbnails,
    isMain: photo.is_main,
    imageNo: photo.image_no,
  })),
  favouriteCount: item.favourite_count,
  user: transformPartialUserDtoToProductItemUser({ business: item.is_owner_business }),
  priceWithDiscount: item.discount_price ? transformCurrencyAmountDto(item.discount_price) : null,
  price: transformCurrencyAmountDto(item.price),
  totalItemPrice: item.total_item_price
    ? transformCurrencyAmountDto(item.total_item_price)
    : undefined,
  thumbnailUrl: getItemThumbnail(item.photos, ItemThumbnailSize.Large),
  dominantColor: getDominantColor(item.photos),
  badge: item.badge,
  isFavourite: item.is_favourite,
  itemBox: item.item_box && transformItemBoxDto(item.item_box),
  isHeavyBulky: item.is_heavy_bulky,
})

export const transformBundleItemDtosToProductItems = (
  items: Array<BundleItemDto>,
): Array<ProductItemModel> => items.map(item => transformBundleItemDtoToProductItem(item))

export const transformUserBundleItems = (response: UserBundleItemsResp): UserBundleItemsModel => ({
  items: transformBundleItemDtosToProductItems(response.items),
  pagination: transformPaginationDto(response.pagination),
})

export const transformUserBundleItemsResponse = (response: Response<UserBundleItemsResp>) =>
  transformUserBundleItems(response)
